import React, { Component } from 'react';
import PropTypes from 'prop-types';

// eslint-disable-next-line react/prefer-stateless-function
class RatingStars extends Component {
  render() {
    return (
      <React.Fragment>
        <i
          className={this.props.rating >= 20 ? 'fa fa-star' : 'fa fa-star-o'}
        />
        <i
          className={this.props.rating >= 40 ? 'fa fa-star' : 'fa fa-star-o'}
        />
        <i
          className={this.props.rating >= 60 ? 'fa fa-star' : 'fa fa-star-o'}
        />
        <i
          className={this.props.rating >= 80 ? 'fa fa-star' : 'fa fa-star-o'}
        />
        <i
          className={this.props.rating >= 100 ? 'fa fa-star' : 'fa fa-star-o'}
        />
      </React.Fragment>
    );
  }
}

RatingStars.propTypes = {
  rating: PropTypes.string.isRequired
};

export default RatingStars;



// WEBPACK FOOTER //
// ./src/components/Rating/RatingStars/RatingStars.js